// TODO add api connection
import { SiteService } from "@/api";

// state
const state = () => ({
	isLoaded: false,
	footer: [],
	donation: [],
	footerMenu: [],
	facebook: "",
	twitter: "",
	instagram: "",
	showLegallyWork: false,
	legallyWorkButton: [],
	legalWorkButtonUrl: [],
	langs: [],
	allMenus: [],
	currentLanguage: "",
	defaultLanguage: "de",
	currentSlug: "",
	page: "home",
	title: "ProCoRe",
	from: null,
	cookie: [],
	strings: [],
});

// getters
const getters = {
	menu: (state) => {
		return state.allMenus[state.currentLanguage];
	},
};

// actions
const actions = {
	async getData({ state, commit }) {
		const resp = await SiteService.getData();
		const {
			footer,
			facebook,
			twitter,
			instagram,
			show_legally_work,
			legally_work_button,
			legal_work_button_url,
			footer_menu,
			languages,
			menu,
			donation,
			default_language,
			current_language,
			title,
			cookie,
			strings,
		} = resp;

		commit("setAllMenus", menu);
		commit("setLanguages", languages);
		commit("setDefaultLanguage", default_language);
		commit("setFooter", footer);
		commit("setDonation", donation);
		commit("setFooterMenu", footer_menu);
		commit("setIsLoaded", true);
		commit("setFacebook", facebook);
		commit("setTwitter", twitter);
		commit("setInstagram", instagram);
		commit("setTitle", title);
		commit("setStrings", strings);
		commit("setCookie", cookie);
		commit("setLegalButtonCopy", legally_work_button);
		commit("setShowLegallyWork", show_legally_work);
		commit("setLegalWorkButtonUrl", legal_work_button_url);

		if (!state.currentLanguage) commit("setCurrentLanguage", current_language);
	},
	setLanguage({ commit }, lang) {
		commit("setCurrentLanguage", lang);
	},
	setSlug({ commit }, slug) {
		commit("setCurrentSlug", slug);
	},
	setPage({ commit }, page) {
		commit("setPage", page);
	},
	setFrom({ commit }, page) {
		commit("setFrom", page);
	},
};

// mutations
const mutations = {
	setLegalWorkButtonUrl(state, legalWorkButtonUrl) {
		state.legalWorkButtonUrl = legalWorkButtonUrl;
	},
	setLegalButtonCopy(state, legallyWorkButton) {
		state.legallyWorkButton = legallyWorkButton;
	},
	setShowLegallyWork(state, showLegallyWork) {
		state.showLegallyWork = showLegallyWork;
	},
	setFacebook(state, facebook) {
		state.facebook = facebook;
	},
	setTwitter(state, twitter) {
		state.twitter = twitter;
	},
	setInstagram(state, instagram) {
		state.instagram = instagram;
	},
	setStrings(state, strings) {
		state.strings = strings;
	},
	setTitle(state, title) {
		state.title = title;
	},
	setCookie(state, cookie) {
		state.cookie = cookie;
	},
	setFooter(state, footer) {
		state.footer = footer;
	},
	setDonation(state, donation) {
		state.donation = donation;
	},
	setFooterMenu(state, footerMenu) {
		state.footerMenu = footerMenu;
	},
	setAllMenus(state, menu) {
		state.allMenus = menu;
	},
	setLanguages(state, langs) {
		state.langs = langs;
	},
	setCurrentLanguage(state, lang) {
		state.currentLanguage = lang;
	},
	setCurrentSlug(state, slug) {
		state.currentSlug = slug;
	},
	setPage(state, page) {
		state.page = page;
	},
	setFrom(state, page) {
		state.from = page;
	},
	setDefaultLanguage(state, lang) {
		state.defaultLanguage = lang;
	},
	setIsLoaded(state, isLoaded) {
		state.isLoaded = isLoaded;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
